import { render, staticRenderFns } from "./search-box.vue?vue&type=template&id=2fd95262&"
import script from "./search-box.vue?vue&type=script&lang=js&"
export * from "./search-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports